import React from 'react';
import { Container, Title, Text, Button } from '@mantine/core';
import { Link } from 'react-router-dom';
import { Card } from '@mantine/core';

const About: React.FC = () => {
  return (
    <Container size="lg" py="xl">
      <Title order={1} mb="lg">
        About HMH Procurement
      </Title>
      
      <Card mb="xl">
        <Title order={2} mb="md">
          Technology Stack
        </Title>
        <Text mb="md">
          This project is built with modern technologies:
        </Text>
        <ul>
          <li><strong>Frontend:</strong> React 18, Vite, Mantine UI, Tailwind CSS</li>
          <li><strong>Backend:</strong> Fastify, TypeScript</li>
          <li><strong>Monorepo:</strong> npm workspaces</li>
          <li><strong>Code Quality:</strong> ESLint, Prettier, TypeScript</li>
        </ul>
      </Card>

      <Button component={Link} to="/" variant="outline">
        Back to Home
      </Button>
    </Container>
  );
};

export default About; 